document.addEventListener('DOMContentLoaded', function () {
    function togglePharmacyPopup() {
        const pharmacyNavItem = document.getElementById('HeaderMenuButton-pharmacy');
        const biosecurityNavItem = document.getElementById('HeaderMenuButton-biosecurity');
        const pharmacyOverlay = document.querySelector('.pharmacy-popup__overlay');
        const pharmacyPopup = document.getElementById('pharmacy-popup');
        const pharmacyStayButton = document.querySelector('.pharmacy-popup__text-stay');
        const pharmacyCloseButton = document.querySelector('.pharmacy-popup__close');
        const pharmacyPopupContent = document.querySelector('.pharmacy-popup__content');

        const closeTriggers = [pharmacyOverlay, pharmacyStayButton, pharmacyCloseButton];

        pharmacyNavItem.addEventListener('click', () => {
            pharmacyPopup.classList.add('active');
            setTimeout(() => {
                trapFocus(pharmacyPopupContent);
            }, 0);
        });

        closeTriggers.forEach(trigger => {
            trigger.addEventListener('click', () => {
                closePopup();
            });

            trigger.addEventListener('keydown', (event) => {
                if (event.key === 'Enter') {
                    closePopup();
                    event.preventDefault();
                    biosecurityNavItem.focus();
                }
            });
        });

        pharmacyPopup.addEventListener('keydown', (event) => {
            if (event.key === 'Escape') {
                closePopup();
                event.preventDefault();
                biosecurityNavItem.focus();
            }
        });

        function closePopup() {
            pharmacyPopup.classList.remove('active');
        }
    }
    togglePharmacyPopup();
});